<div class="display-widget-container">
  <div class="item-header bg-{{ theme }} uppercase">
    <div class="header-content">
      <div>
        <ng-content select="[actions-left]"></ng-content>
      </div>
      <ng-container *ngIf="title === ''; else customTitle">
        <ng-content select="[title]"></ng-content>
      </ng-container>
      <ng-template #customTitle>
        <span
          class="title font-bold"
          >{{ title }}</span
        ></ng-template
      >
      <div>
        <ng-content select="[actions-right]"></ng-content>
        <svg-icon
          *ngIf="useExpandFeatures"
          class="toggle-icon"
          [src]="
            isExpanded
              ? 'assets/icons/icon-hide.svg'
              : 'assets/icons/icon-show.svg'
          "
          (click)="toggleExpanded()"
        ></svg-icon>
      </div>
    </div>
  </div>
  <div
    *ngIf="!oNCollapseShowNothing || isExpanded"
    class="item-content"
    [ngStyle]="{ '--content-bg-color': 'var(--' + contentTheme + ')' }"
    [class.expanded]="isExpanded && useExpandFeatures"
    [class.content-border]="applyContentBorder"
    [attr.data-opacity]="contentOpacity"
  >
    <ng-content
      select=":not([actions-left]):not([actions-right]):not([title])"
    ></ng-content>
  </div>
</div>
